import React, { useCallback, useState, useLayoutEffect, CSSProperties, useEffect, useRef } from "react";
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import Overlay from "../Overlay";
import Select from "react-select";
import { sweetalert } from "../../App";
import SimpleTable from "../tables/SimpleTable";
import { BatchSelect } from "./selects/BatchSelect";
import Batch from "../../types/Batch";
import TestsAPI from "../../network/TestsAPI";
import BatchesAPI from "../../network/BatchesAPI";
import ResultsAPI from "../../network/ResultsAPI";
import { isEmptyObject } from "jquery";
import ServicesAPI from "../../network/ServicesAPI";
import { buildRow, getDateOrNull, getIDFromLabel, getLabel, getLabelFromName, getNameFromAbbreviation, getNameFromID, getlabelsFromIDs, parseDate, parseDateForCustomDate, capitalize, parseDateForCSVImport, getProviderIDFromLabel } from "../../util/FormatUtil";
import AdminAPI from "../../network/AdminAPI";
import FacilityType from "../../types/Facility";
import SamplesAPI from "../../network/SamplesAPI";
import { useCSVReader, lightenDarkenColor, formatFileSize, } from 'react-papaparse';
import NetworkUtil from "../../network/NetworkUtil";
import SystemAPI from "../../network/SystemAPI";
import GetField from "../../customfields/GetField";
import Validator, { ValidationEntry } from "../../validation/Validator";
import { Validators } from "../../validation/Validators";
import CustomFieldsAPI from "../../network/CustomFieldsAPI";
import { CustomFields } from "../../types/CustomFieldType";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import PhoneInput from 'react-phone-number-input';
import { isValidEmail } from "../../util/ValidationUtil";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import ProviderAPI from "../../network/ProviderAPI";



type SampleCSVImportProps = {};

// will need to update these hardcoded values on front and back so that template matches uploaded csv
// headers are on line 8

const GREY = '#CCC';
const GREY_LIGHT = 'rgba(255, 255, 255, 0.4)';
const DEFAULT_REMOVE_HOVER_COLOR = '#A01919';
const REMOVE_HOVER_COLOR_LIGHT = lightenDarkenColor(
    DEFAULT_REMOVE_HOVER_COLOR,
    40
);
const GREY_DIM = '#686868';

const styles = {
    zone: {
        alignItems: 'center',
        border: `2px dashed ${GREY}`,
        borderRadius: 20,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        padding: 20,
        marginBottom: 10
    } as CSSProperties,
    file: {
        background: 'linear-gradient(to bottom, #EEE, #DDD)',
        borderRadius: 20,
        display: 'flex',
        height: 120,
        width: 120,
        position: 'relative',
        zIndex: 10,
        flexDirection: 'column',
        justifyContent: 'center',
    } as CSSProperties,
    info: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: 10,
        paddingRight: 10,
    } as CSSProperties,
    size: {
        backgroundColor: GREY_LIGHT,
        borderRadius: 3,
        marginBottom: '0.5em',
        justifyContent: 'center',
        display: 'flex',
    } as CSSProperties,
    name: {
        backgroundColor: GREY_LIGHT,
        borderRadius: 3,
        fontSize: 12,
        marginBottom: '0.5em',
    } as CSSProperties,
    progressBar: {
        bottom: 14,
        position: 'absolute',
        width: '100%',
        paddingLeft: 10,
        paddingRight: 10,
    } as CSSProperties,
    zoneHover: {
        borderColor: GREY_DIM,
    } as CSSProperties,
    default: {
        borderColor: GREY,
    } as CSSProperties,
    remove: {
        height: 23,
        position: 'absolute',
        right: 6,
        top: 6,
        width: 23,
    } as CSSProperties,
};


export const SampleCSVImport = ({ }: SampleCSVImportProps) => {

    const { CSVReader } = useCSVReader();
    const [zoneHover, setZoneHover] = useState(false);
    const [removeHoverColor, setRemoveHoverColor] = useState(
        DEFAULT_REMOVE_HOVER_COLOR
    );

    const [firstTimeThrough, setFirstTimeThrough] = useState(true)
    const [submitButtonClicked, setSubmitButtonClicked] = useState(false)
    const [services, setServices] = useState([])
    const [facilities, setFacilities] = useState([])
    const [fiftyStates, setFiftyStates] = useState([])
    const [showLoading, setShowLoading] = useState(true)
    const [tableData, setTableData] = useState([])
    const [allCustomQuestions, setAllCustomQuestions] = useState([])
    const [selectedService, setSelectedService] = useState(null)
    const [selectedFacility, setSelectedFacility] = useState(null)
    const [importedCSVFacility, setImportedCSVFacility] = useState(null)
    const [importedCSVService, setImportedCSVService] = useState(null)
    const [importedCSVTests, setImportedCSVTests] = useState(null)
    const [importedCSVSpecimenSources, setImportedCSVSpecimenSources] = useState(null)
    const [importedCSVSubmittingProviders, setImportedCSVSubmittingProviders] = useState(null)
    const [allSubmittingProviders, setAllSubmittingProviders] = useState([])
    const [selectedFacilitySubmittingProviders, setSelectedFacilitySubmittingProviders] = useState(null)


    const getData = async () => {
        AdminAPI.getFacilitiesForSubmissionForm().then((data) => {
            setFacilities(data.authorizedFacilities)
        })
        CustomFieldsAPI.getAllCustomFields().then(data => {
            let customQuestions = data.data.customQuestions;
            customQuestions = customQuestions.filter(cq => cq.Options.isActive)
    
            let customPatientFields = data.data.customPatientFields;
            customPatientFields = customPatientFields.filter(cp => cp.Options.isActive)

            let combinedCustom = customQuestions.concat(customPatientFields);
            setAllCustomQuestions(combinedCustom)
        })
        ServicesAPI.getServicesForSubmissionForm().then((data) => {
            setServices(data.data)
            setShowLoading(false)
        });

        ProviderAPI.getAllSubmittingProviders().then(response => {
            setAllSubmittingProviders(response.data)
        })
        SystemAPI.getAllStates().then((response) => {
          setFiftyStates(response);
        });
    }

    useLayoutEffect(() => {
        // console.log('useLayoutEffect');
        getData();
    }, [])

    useEffect(() => {
      // update picklist of providers when importedCSVFacility changes
      getSubmittingProvidersForSelectedFacility();
    }, [importedCSVFacility]);


    const handleExportToCSV = async () => {
        setShowLoading(true)
        await NetworkUtil.downloadCSV(
            "/api/admin/bulkSamplesCSVExport",
            `${importedCSVService.Name}Service Bulk Sample Export.xlsx`,
            { data: tableData });
        setShowLoading(false);
    }

    const validateTable = async () => {
        // console.log('validateTable');
        setShowLoading(true)

        //check that facility has service
        let facility = importedCSVFacility && importedCSVFacility.value ? facilities.find(f => f.ID === importedCSVFacility.value) : null;
        if (!facility) {
            setShowLoading(false)
            return sweetalert.fire({ icon: 'error', title: '', text: `Importing Facility cannot be blank` })

        }
        let facilityServiceIDs = JSON.parse(facility.ServiceIDs)

        if (!facilityServiceIDs.includes(importedCSVService.ID)) {
            setShowLoading(false)
            return sweetalert.fire({ icon: 'error', title: '', text: `${importedCSVService.Name} does not belong to ${facility.FacilityName}` })
        }

        if (!tableData || tableData.length < 1) {
            setShowLoading(false)
            return sweetalert.fire("", "All required fields in table must be complete", "error")
        }

        let specimenIDs = [];
        let serviceQuestions = ['Tests *', 'Provider Full Name (NPI #) *', 'Specimen Source *', 'Accession ID', 'Memo', 'Collection Date *', 'Test Ordered Date *'];

        let validated = true;
        for (let i = 0; i < tableData.length; i++) {
            for (let key in tableData[i]) {
                if (tableData[i].hasOwnProperty(key)) {
                    if (serviceQuestions.includes(key)) {
                        continue;
                    }

                    if (!allCustomQuestions.find(f => f.DisplayName === key)) {
                      if(key === 'No Insurance/ No MaineCare'){
                        key = 'Check if patient has No Private Insurance AND No MaineCare coverage'; // set back to actual DisplayName
                      } else {
                        // console.log(key, 'not found in allCustomQuestions')
                        setShowLoading(false)
                        return sweetalert.fire({ icon: 'error', title: '', text: 'Something went wrong. Make sure you are using the latest Excel document.' })
                      }
                    }
                    validated = validate(i, key, allCustomQuestions.find(f => f.DisplayName === key))
                    if (!validated) {
                        return;
                    }
                }
            }

            //Tests - required
            if (tableData[i]['Tests *']) {
                let splitStringArray;
                let testsArray = [];
                //check if array. if not, convert to array.
                // console.log(tableData[i]['Tests'])
                if (!Array.isArray(tableData[i]['Tests *']) && !Number(tableData[i]['Tests *']) && typeof tableData[i]['Tests *'] === 'string') {
                    //This conditional catches the Tests if they havent been changed after importing from the CSV
                    splitStringArray = tableData[i]['Tests *'].split(",");


                    for (let j = 0; j < splitStringArray.length; j++) {
                        let result = getIDFromLabel(splitStringArray[j].trim(), importedCSVTests);
                        if (result) {
                            testsArray.push({ label: splitStringArray[j].trim(), value: result })
                        }
                        else {
                            setShowLoading(false)
                            return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: ${splitStringArray[j]}</b> is not valid. Please select valid tests from the dropdown.</p>` })
                        }
                    }
                    tableData[i]['Tests *'] = testsArray;
                } else if (!Array.isArray(tableData[i]['Tests *']) && !Number(tableData[i]['Tests *']) && typeof tableData[i]['Tests *'] === 'object') {
                    //This conditional catches the Tests if they have been changed after importing from the CSV and they only have one test selected
                    tableData[i]['Tests *'] = [tableData[i]['Tests *']]

                } else {
                    //check if array label matches name in importedCSVTests
                    for (let j = 0; j < tableData[i]['Tests *'].length; j++) {
                        let valid = !!importedCSVTests.find(f => f.Name === tableData[i]['Tests *'][j].label)
                        if (!valid) {
                            setShowLoading(false)
                            return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: ${tableData[i]['Tests *'][j].label}</b> is not valid. Please select valid tests from the dropdown.</p>` })
                        }
                    }
                }
            }
            else {
                setShowLoading(false)
                return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Tests</b> cannot be blank</p>` })
            }

            //Specimen Source - required
            if (tableData[i]['Specimen Source *']) {
                if (!Number(tableData[i]['Specimen Source *'])) {
                    // console.log(tableData[i]['Specimen Source'])
                    tableData[i]['Specimen Source *'] = typeof tableData[i]['Specimen Source *'] === "object" ? tableData[i]['Specimen Source *'][0].value : getIDFromLabel(tableData[i]['Specimen Source *'].trim(), importedCSVSpecimenSources);
                }

            }
            else {
                setShowLoading(false)
                return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Specimen Source</b> cannot be blank</p>` })
            }

            //Specimen ID - required for IsLabService = true // AH: Accession ID aka SpecimenID is not required
            // if (importedCSVService.IsLabService && (!tableData[i]['Accession ID'] || tableData[i]['Accession ID'].length < 1)) {
            //     setShowLoading(false)
            //     return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Accession ID</b> cannot be blank</p>` })
            // }
            //Specimen ID - check for duplicates in tableData // AH: Duplicate Accession IDs allowed for Maine
            // specimenIDs.push(tableData[i]['Accession ID']);

            //Submitting Provider - required
            if (tableData[i]['Provider Full Name (NPI #) *']) {
                if (!Number(tableData[i]['Provider Full Name (NPI #) *'])) {
                    if (typeof tableData[i]['Provider Full Name (NPI #) *'] === "object") {
                        // If it's already an object, extract the value
                        if (Array.isArray(tableData[i]['Provider Full Name (NPI #) *'])) {
                            tableData[i]['Provider Full Name (NPI #) *'] = tableData[i]['Provider Full Name (NPI #) *'][0].value;
                        } else {
                            tableData[i]['Provider Full Name (NPI #) *'] = tableData[i]['Provider Full Name (NPI #) *'].value;
                        }
                    } else {
                        tableData[i]['Provider Full Name (NPI #) *'] = getProviderIDFromLabel(tableData[i]['Provider Full Name (NPI #) *'].trim(), selectedFacilitySubmittingProviders);
                        if(!tableData[i]['Provider Full Name (NPI #) *']){ // we did not fine a matching provider for the selected facility
                          // TODO: add option to create new provider here - logic can be found in ServiceFormModal.tsx
                          setShowLoading(false)
                          return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Provider Full Name (NPI #)</b> is not valid. Please select a valid provider from the dropdown. If you do not see the Provider listed, one may be created through the Provider Management feature.</p>` })
                        }
                    }
                }
            }
            else {
                setShowLoading(false)
                return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Provider Full Name (NPI #)</b> cannot be blank</p>` })
            }

            //Collection Date - required
            if (!tableData[i]['Collection Date *']) {
                setShowLoading(false)
                return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Collection Date</b> must be a valid date.</p>` })
            }
            if (new Date(tableData[i]['Collection Date *']) > new Date()) {
                setShowLoading(false)
                return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Collection Date</b> cannot be in the future.</p>` })
            }
            if (tableData[i]['Date of Birth *'] && new Date(tableData[i]['Collection Date *']) < new Date(tableData[i]['Date of Birth *'])) {
              setShowLoading(false)
              return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Collection Date</b> cannot be before Patient Date of Birth.</p>` })
            }
            if (new Date(tableData[i]['Collection Date *']) < new Date('01/01/1970')) {
                setShowLoading(false)
                return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Collection Date</b> cannot be before 01/01/1970.</p>` })
            }
            //Test Ordered Date - required
            if (!tableData[i]['Test Ordered Date *']) {
                setShowLoading(false)
                return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Test Ordered Date</b> must be a valid date.</p>` })
            }
            if (new Date(tableData[i]['Test Ordered Date *']) > new Date()) {
                setShowLoading(false)
                return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${i + 1}: Test Ordered Date</b> cannot be in the future.</p>` })
            }

            // MaineCare #, if provided, must be 9 characters and end in A
            if(tableData[i]["MaineCare #"]){
              // validate MaineCare # format
              if(tableData[i]["MaineCare #"] !== null && tableData[i]["MaineCare #"] !== undefined){
                if(tableData[i]["MaineCare #"].length !== 9 || !tableData[i]["MaineCare #"].endsWith('A')) {
                  setShowLoading(false)
                  return sweetalert.fire({ icon: 'error', title: '', text: `Row ${i + 1}: MaineCare # must be 9 characters and end in A` })
                }
              }
            }
        }

        // check for duplicate Specimen IDs  -- UPDATE Maine allows duplicate Specimen IDs
        // let duplicates = specimenIDs.filter((item, index) => specimenIDs.indexOf(item) !== index)
        // if (duplicates.length > 0) {
        //     setShowLoading(false)
        //     return sweetalert.fire({ icon: 'error', title: '', text: "Duplicate Accession IDs detected" });
        // }

        //set up object to be sent to backend
        let tableDataForBackend = JSON.parse(JSON.stringify(tableData));
        // console.log('tableDataForBackend', tableDataForBackend)
        submit(tableDataForBackend)

    }
//TODO SELECT FIELDS ARE BROKEN AND NEED TO BE FORMATTED TO PROPERLY SUBMIT, THE CODE ORIGINALLY STORED JUST THE VALUE, BUT WE NEEDED TO CHANGE IT TO STORE THE WHOLE LABEL/ VALUE PROPERTIES
    const submit = async (tableDataToSubmit) => {
        // console.log('gn2 submit', tableDataToSubmit)
        let facility = facilities.find(f => f.ID === importedCSVFacility.value)
        let facilityServiceIDs = JSON.parse(facility.ServiceIDs)
        if (!facilityServiceIDs.includes(importedCSVService.ID)) {
            setShowLoading(false)
            return sweetalert.fire({ icon: 'error', title: '', html: `<p><b>${importedCSVService.Name}</b> does not belong to <b>${facility.FacilityName}</b></p>` })
        }
        for (let i = 0; i < tableDataToSubmit.length; i++) {
            tableDataToSubmit[i]['Facility'] = importedCSVFacility;
            tableDataToSubmit[i]['Service'] = importedCSVService;
            for (const key in tableDataToSubmit[i]) {
                if (tableDataToSubmit[i].hasOwnProperty(key)){
                    if (key === 'Tests *') {
                        if (Array.isArray(tableDataToSubmit[i][key])) {
                            tableDataToSubmit[i][key] = tableDataToSubmit[i][key].map(m => { return Number(m.value) ? m.value : importedCSVTests.find(t => m.value == t.Name).ID });
                        }
                    }

                    if (key === 'Collection Date *' || key === 'Test Ordered Date *') {
                        tableDataToSubmit[i][key] = getDateOrNull(new Date(tableDataToSubmit[i][key]))
                    }

                    if (key === 'No Insurance/ No MaineCare') {
                      if (tableDataToSubmit[i][key] === "True") {
                        // bill SAMCLP
                        tableDataToSubmit[i]['Bill Other'] = 'True'
                        tableDataToSubmit[i]['Bill Other Submitter'] = 'SAMCLP'
                      }
                    }
                    if (key === "MaineCare #") {
                      if (tableDataToSubmit[i][key] !== "") {
                        tableDataToSubmit[i]['Bill Other'] = 'True'
                        tableDataToSubmit[i]['Bill Other Submitter'] = 'SAMCD'
                      }
                    }

                    for (let j = 0; j < allCustomQuestions.length; j++) {
                        let DisplayName = allCustomQuestions[j].DisplayName;
                        if (DisplayName === key) {
                            //covert date format
                            if (allCustomQuestions[j].FieldTypeID === CustomFields.DATE_FIELD) {
                                tableDataToSubmit[i][key] = tableDataToSubmit[i][key] && new Date(tableDataToSubmit[i][key]) ? parseDate(new Date(tableDataToSubmit[i][key])) : null;
                            }
                            //convert phone
                            if (allCustomQuestions[j].FieldTypeID === CustomFields.PHONE_FIELD) {
                                let justNumbers = tableDataToSubmit[i][key].replace(/\D/g, '');

                                if(justNumbers.length === 0){ tableDataToSubmit[i][key] = ""; continue;}
                                tableDataToSubmit[i][key] = `+1${justNumbers}`;
                            }

                            if (allCustomQuestions[j].FieldTypeID === CustomFields.SELECT_FIELD) {
                                if (allCustomQuestions[j].Options.isMulti) {
                                    // const temp = tableDataToSubmit[i][key].map(m => { return m.value });
                                }
                                else {
                                    tableDataToSubmit[i][key] = tableDataToSubmit[i][key][0];
                                }
                            }
                        }
                    }
                }
            }
        }


        let response = await AdminAPI.createImportedSamples(tableDataToSubmit)
        if (!response.success) {
            let msg = "Unable to create Samples at this time.";
            if (response.reason) {
                msg = response.reason
            }
            setShowLoading(false)
            return sweetalert.fire({ icon: 'error', title: "", text: msg });
        }

        sweetalert.fire({ icon: 'success', title: '', text: 'Samples created' })
            .then(() => {
                setSubmitButtonClicked(true)
                setShowLoading(false)
                setTableData(response.createdSamples)
            });

        setShowLoading(false)
    }

    const clearTable = () => {
        getData();
        setTableData(null)
        setSubmitButtonClicked(false)
        setImportedCSVFacility(null)
    }


    const handleCellChange = (e, rowIndex, columnName, fieldTypeID) => {
        // console.log(e, rowIndex, columnName, fieldTypeID)
        const updatedData = [...tableData];

        if (fieldTypeID === CustomFields.DATE_FIELD) {
            updatedData[rowIndex][columnName] = !e ? '' : e;
        }
        else if (fieldTypeID === CustomFields.DATETIME_FIELD) {
            updatedData[rowIndex][columnName] = !e ? '' : e;
        }
        else if (fieldTypeID === CustomFields.SELECT_FIELD) {
            // console.log('e', !e ? null : Array.isArray(e) ? e : e)
            updatedData[rowIndex][columnName] = !e ? null : Array.isArray(e) ? e : [e]; // ensure single item select is an array with one object
            // console.log("updatedData[rowIndex][columnName]", updatedData[rowIndex][columnName])
        }
        else {
            updatedData[rowIndex][columnName] = !e ? '' : e.target.value;
        }
        
        // console.log("updatedData", updatedData)
        setTableData(updatedData);
    };


    // Yes/No fields have not always been configured with the same option values
    // ('True'/'False', 'Yes'/'No', booleans), so resolve a cell against the field's
    // own options instead of assuming what the value should be.
    const normalizeYesNo = (value) => {
        if (value === true) { return 'yes' }
        if (value === false) { return 'no' }
        if (typeof value !== 'string') { return null }
        const lowered = value.trim().toLowerCase();
        if (lowered === 'yes' || lowered === 'y' || lowered === 'true' || lowered === '1') { return 'yes' }
        if (lowered === 'no' || lowered === 'n' || lowered === 'false' || lowered === '0') { return 'no' }
        return null;
    }

    const getYesNoOption = (customField, cellValue) => {
        const normalized = normalizeYesNo(cellValue);
        if (!normalized) { return null }
        const options = customField && customField.Options ? customField.Options.options : null;
        if (!options || options.length < 1) { return null }
        return options.find(o => normalizeYesNo(o.label) === normalized) ||
            options.find(o => normalizeYesNo(o.value) === normalized) ||
            null;
    }

    const validate = (rowIndex, header, customField) => {
        // console.log('rowIndex', rowIndex);
        // console.log('header', header);
        // console.log('customField', customField);
        let fieldTypeID = customField && customField.FieldTypeID ? customField.FieldTypeID : null;
        if (fieldTypeID === CustomFields.DATE_FIELD || fieldTypeID === CustomFields.DATETIME_FIELD) {
            const minInputDate= new Date('1900-01-01');

            let DateField = new Date(tableData[rowIndex][header]);
            let PatientDOB = new Date(tableData[rowIndex]['Date of Birth *']);

            //required validation
            if (customField.Options.isRequired) {
                if (!tableData[rowIndex][header] && tableData[rowIndex][header] !== 0) {
                    setShowLoading(false);
                    sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> must be a valid date</p>` })
                    return false
                }
            }

            if(header === 'Date of Birth *'){
                // ensure date of birth is a valid date
                if (PatientDOB && isNaN(PatientDOB.getTime())) {
                  setShowLoading(false);
                  sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> must be a valid date</p>` })
                  return false
                }
                // ensure date of birth is not before 1/1/1900
                if (PatientDOB < minInputDate) {
                  setShowLoading(false);
                  sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> cannot be before January 1, 1900</p>` })
                  return false;
                }
            }

          if (header === 'Collection Date *' || header === 'Test Ordered Date *') {
            // ensure date is a valid date
            if (DateField && isNaN(DateField.getTime())) {
              setShowLoading(false);
              sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> must be a valid date</p>` })
              return false
            }
            // ensure date is before min date, ensure date is not before patient DOB
            if (DateField < minInputDate) {
              setShowLoading(false);
              sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> cannot be before January 1, 1900</p>` })
              return false;
            }
            if (PatientDOB && DateField < PatientDOB) {
              setShowLoading(false);
              sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> cannot be before Patient DOB</p>` })
              return false;
            }
          }
        }
        else if (fieldTypeID === CustomFields.SELECT_FIELD) {
            // Explicit null/undefined check at the very start
            const currentValue = tableData[rowIndex][header];

            if (currentValue === null || currentValue === undefined) {
                if (customField.Options.isRequired) {
                    setShowLoading(false);
                    sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> cannot be blank</p>` })
                    return false;
                }
                return true;
            }

            if (customField.Options.isRequired) {
                if (!currentValue) {
                    setShowLoading(false);
                    sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> cannot be blank</p>` })
                    return false
                }
            }

            // If value is already in correct object format, skip conversion
            const isAlreadyFormatted = currentValue && typeof currentValue === 'object' &&
                (Array.isArray(currentValue) ? currentValue.every(v => v && typeof v === 'object' && 'label' in v && 'value' in v) :
                ('label' in currentValue && 'value' in currentValue));

            if (isAlreadyFormatted) {
                return true;
            }

            // If value is null/empty and not required, it's valid
            if (!tableData[rowIndex][header]) {
                return true;
            }
            if (typeof tableData[rowIndex][header] === 'string' && tableData[rowIndex][header].length === 0) {
                return true;
            }

            let splitStringArray;
            let tempArray = [];
            //check if array. if not, convert to array.
            if (tableData[rowIndex][header] && !Array.isArray(tableData[rowIndex][header]) && !Number(tableData[rowIndex][header]) && header != 'Tests *') {

                splitStringArray = typeof tableData[rowIndex][header] === 'string' ? tableData[rowIndex][header].split(",") : customField.Options.isMulti ? [tableData[rowIndex][header]] : tableData[rowIndex][header]

                // console.log("splitStringArray", splitStringArray, splitStringArray.length)

                // Only process if splitStringArray is valid and has length
                if (!splitStringArray || !splitStringArray.length || (typeof splitStringArray === 'object' && !Array.isArray(splitStringArray))) {
                    return true;
                }

                // A single-select option label can itself contain a comma, so check the
                // whole cell against the options before treating commas as separators.
                if (!customField.Options.isMulti && customField.Options.options &&
                    typeof tableData[rowIndex][header] === 'string' && tableData[rowIndex][header].includes(',')) {
                    const cellText = tableData[rowIndex][header].trim().toLowerCase();
                    const wholeCellOption = customField.Options.options.find(o =>
                        (typeof o.label === 'string' && o.label.trim().toLowerCase() === cellText) ||
                        (typeof o.value === 'string' && o.value.trim().toLowerCase() === cellText));
                    if (wholeCellOption) {
                        tableData[rowIndex][header] = [{ label: wholeCellOption.label, value: wholeCellOption.value }];
                        return true;
                    }
                }

                for (let i = 0; i < splitStringArray.length; i++) {
                    // console.log("went in for loop")
                    //verify each element value is in options
                    if (customField && customField.Options && customField.Options.options) {
                        //check for yes/no
                        const yesNoOption = getYesNoOption(customField, splitStringArray[i]);
                        if (yesNoOption) {
                            tempArray.push({ label: yesNoOption.label, value: yesNoOption.value })
                            continue;
                        }

                        // state
                        if (header === 'State *' && customField?.Options?.options?.length > 0) {
                          // ensure its a state name
                          const stateObj = fiftyStates.find(s => s.label === splitStringArray[i].trim());
                          if(stateObj) {
                            tempArray.push({ label: stateObj.label, value: stateObj.label});
                            continue;
                          } else {
                            setShowLoading(false);
                            sweetalert.fire({ icon: "error", title: '', html: `<p><b>Row ${rowIndex + 1} - ${customField.DisplayName}: <i>${splitStringArray[i]}</i></b> is not a valid State. Please select a valid option from the dropdown.</p>` })
                            return;
                          }
                        }
                        //specimen source
                        let specimenSourceFound = false;
                        if (header === 'Specimen Source *' && customField?.Options?.options?.length > 0) {
                            for (let j = 0; j < customField.Options.options.length; j++) {
                                // console.log(splitStringArray[i])
                                if (customField.Options.options[j].label === splitStringArray[i].label) {
                                    tempArray.push(splitStringArray[i])
                                    specimenSourceFound = true;
                                    continue;
                                }
                            }
                        }
                        if (specimenSourceFound) {
                            continue;
                        }

                        // console.log('splitStringArray[i]', splitStringArray[i])
                        const objFound = customField.Options.options.filter(obj => (obj.value == splitStringArray[i].value) || (obj.label == splitStringArray[i].label) || (obj.label == splitStringArray[i]));
                        if (objFound && objFound.length > 0) {
                            tempArray.push(objFound[i])
                            continue;
                        }
                        else {
                            // console.log('gn2 1');
                            sweetalert.fire({ icon: "error", title: '', html: `<p><b>Row ${rowIndex + 1} - ${customField.DisplayName}: <i>${splitStringArray[i]}</i></b> is not valid. Please select valid options from the dropdown.</p>` })
                            setShowLoading(false)
                            return;
                        }
                    }
                    else {
                        sweetalert.fire({ icon: "error", title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> has no options.</p>` })
                        setShowLoading(false)
                        return false;
                    }
                }
                // console.log('tempArray', tempArray, tableData[rowIndex][header])
                tableData[rowIndex][header] = tempArray ? tempArray : tableData[rowIndex][header];
            }
            else if (Array.isArray(tableData[rowIndex][header]) && header != 'Tests *') {
                // console.log('header', header)
                // console.log('customField', customField)
                // console.log('tableData[rowIndex][header]', tableData[rowIndex][header])

                // Safety check for empty or null arrays
                if (!tableData[rowIndex][header] || tableData[rowIndex][header].length === 0) {
                    return true;
                }

                for (let i = 0; i < tableData[rowIndex][header].length; i++) {
                    if (customField && customField.Options && customField.Options.options) {
                        //check for yes/no
                        const yesNoOption = getYesNoOption(customField, tableData[rowIndex][header][i]);
                        if (yesNoOption) {
                            tempArray.push({ label: yesNoOption.label, value: yesNoOption.value })
                            continue;
                        }

                        // state
                        if (header === 'State *' && customField?.Options?.options?.length > 0) {
                          // ensure its a state name
                          const stateObj = fiftyStates.find(s => s.label === splitStringArray[i].trim());
                          if(stateObj) {
                            tempArray.push({ label: stateObj.label, value: stateObj.label});
                            continue;
                          } else {
                            setShowLoading(false);
                            sweetalert.fire({ icon: "error", title: '', html: `<p><b>Row ${rowIndex + 1} - ${customField.DisplayName}: <i>${splitStringArray[i]}</i></b> is not a valid State. Please select a valid option from the dropdown.</p>` })
                            return;
                          }
                        }

                        //specimen source
                        let specimenSourceFound = false;
                        if (header === 'Specimen Source *' && customField?.Options?.options?.length > 0) {
                            for (let j = 0; j < customField.Options.options.length; j++) {
                                // console.log(tableData[rowIndex][header][i])
                                const currentValue = typeof tableData[rowIndex][header][i] === 'string' ? tableData[rowIndex][header][i].trim() : tableData[rowIndex][header][i];
                                if (customField.Options.options[j].label === currentValue) {
                                    tempArray.push({ label: currentValue, value: customField.Options.options[j].value })
                                    specimenSourceFound = true;
                                    continue;
                                }
                            }
                        }
                        if (specimenSourceFound) {
                            continue;
                        }
                        const objFound = customField.Options.options.filter(obj => (obj.value == (typeof tableData[rowIndex][header] == "string" ? tableData[rowIndex][header][i].trim() : tableData[rowIndex][header][i].value)) || (obj.label == (typeof tableData[rowIndex][header] == "string" ? tableData[rowIndex][header][i].trim() : tableData[rowIndex][header][i].label)));
                        if (objFound && objFound.length > 0) {
                            continue;
                        }
                        else {
                            // console.log('gn2 2');
                            sweetalert.fire({ icon: "error", title: '', html: `<p><b>Row ${rowIndex + 1} - ${customField.DisplayName}: <i>${tableData[rowIndex][header][i].value}</i></b> is not valid. Please select valid options from the dropdown.</p>` })
                            setShowLoading(false)
                            return;
                        }
                    }
                    else {
                        sweetalert.fire({ icon: "error", title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> has no options.</p>` })
                        setShowLoading(false)
                        return false;
                    }
                }
            }
        }
        else if (fieldTypeID === CustomFields.NUMBER_FIELD) {
            if (customField.Options.isRequired) {
                if (!tableData[rowIndex][header] && Number(tableData[rowIndex][header]) !== 0) {
                    setShowLoading(false);
                    sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> cannot be blank</p>` })
                    return false
                }
                else if (String(tableData[rowIndex][header]).length < 1) {
                    setShowLoading(false);
                    sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> cannot be blank</p>` })
                    return false
                }
            }
        }
        else {
            if (customField.Options.isRequired) {
                if (!tableData[rowIndex][header] || tableData[rowIndex][header].trim().length < 1) {
                    setShowLoading(false);
                    sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> cannot be blank</p>` })
                    return false
                }
            }
        }

        //max-length validation
        if ((fieldTypeID === CustomFields.TEXT_FIELD || fieldTypeID === CustomFields.TEXTAREA_FIELD) && tableData[rowIndex][header] && tableData[rowIndex][header].length > 0 && customField.Options.maxLength) {
            if (!tableData[rowIndex][header] || tableData[rowIndex][header].length > customField.Options.maxLength) {
                setShowLoading(false);
                sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> cannot be longer than ${customField.Options.maxLength} characters</p>` })
                return false
            }
        }

        //email format validation
        if (fieldTypeID === CustomFields.EMAIL_FIELD && tableData[rowIndex][header] && tableData[rowIndex][header].length > 0) {
            if (!tableData[rowIndex][header] || !isValidEmail(tableData[rowIndex][header])) {
                setShowLoading(false);
                sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> must be a valid email</p>` })
                return false
            }
        }

        //phone format validation
        if (fieldTypeID === CustomFields.PHONE_FIELD && tableData[rowIndex][header] && tableData[rowIndex][header].length > 0) {
            let phoneNumber = `+1${tableData[rowIndex][header]}`;
            if (!tableData[rowIndex][header] || !isPossiblePhoneNumber(phoneNumber)) {
                setShowLoading(false);
                sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> must be a valid phone number</p>` })
                return false
            }
        }

        //is numeric and within range
        if (fieldTypeID === CustomFields.NUMBER_FIELD && (tableData[rowIndex][header] || tableData[rowIndex][header] == 0)) {
            let number = Number(tableData[rowIndex][header]);
            if (isNaN(number)) {
                setShowLoading(false);
                sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> must be a valid number</p>` })
                return false
            }
            if (number < customField.Options.min || number > customField.Options.max) {
                setShowLoading(false);
                sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> must be within range of <b>${customField.Options.min}</b> and <b>${customField.Options.max}</b></p>` })
                return false
            }
        }

        //allow future date

        if ((fieldTypeID === CustomFields.DATE_FIELD || fieldTypeID === CustomFields.DATETIME_FIELD) && tableData[rowIndex][header]) {
            if (!customField.Options.allowFutureDate && new Date(tableData[rowIndex][header]) > new Date()) {
                setShowLoading(false);
                sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowIndex + 1}: ${customField.DisplayName}</b> cannot be a future date</p>` })
                return false
            }
        }

        return true;
    }


    const getTableHeaders = () => {
        let keys = Object.keys(tableData[0])
        let jsx = [];
        if (tableData[0].ReqNum) {
            for (let i = 0; i < keys.length; i++) {
                jsx.push(<th key={i} style={{ width: "17rem", position: "sticky", top: 0, backgroundColor: '#fff', zIndex: 2 }}>{keys[i]}</th>)
            }
        }
        else {
            jsx.push(<th style={{ width: "4rem", position: "sticky", top: 0, backgroundColor: '#fff', zIndex: 2 }}>#</th>)
            for (let i = 0; i < keys.length; i++) {
                if (keys[i] === 'ID' || keys[i] === 'ReqNum') {
                    continue
                }
                jsx.push(<th key={i} style={{ width: "17rem", position: "sticky", top: 0, backgroundColor: '#fff', zIndex: 2 }}>{keys[i]}</th>)
            }
        }

        return jsx;
    }

    // Cells already warned about, so the warning is not re-fired on every render
    const multipleSelectionWarnings = useRef(new Set<string>());

    const getTableRows = () => {

        let serviceFields = [
            {
                DisplayName: 'Tests *',
                FieldTypeID: CustomFields.SELECT_FIELD,
                Options: {
                    isMulti: importedCSVService ? importedCSVService.AllowMultipleTests : false,
                    options: importedCSVTests && importedCSVTests.length > 0 ? importedCSVTests.map(it => { return { label: it.Name, value: it.ID } }) : [],
                    isRequired: true
                }
            },
            {
                DisplayName: 'Provider Full Name (NPI #) *',
                FieldTypeID: CustomFields.SELECT_FIELD,
                Options: {
                    isMulti: false,
                    options: selectedFacilitySubmittingProviders && selectedFacilitySubmittingProviders.length > 0 ? selectedFacilitySubmittingProviders : [],
                }
            },
            {
                DisplayName: 'Accession ID',
                FieldTypeID: CustomFields.TEXT_FIELD,
                Options: {
                    // isRequired: importedCSVService && importedCSVService.IsLabService ? true : false,
                    maxLength: 50,
                }
            },
            {
                DisplayName: 'Specimen Source *',
                FieldTypeID: CustomFields.SELECT_FIELD,
                Options: {
                    isMulti: false,
                    options: importedCSVSpecimenSources && importedCSVSpecimenSources.length > 0 ? importedCSVSpecimenSources : [],
                    isRequired: true
                },
            },
            {
                DisplayName: 'Memo',
                FieldTypeID: CustomFields.TEXTAREA_FIELD,
                Options: {
                    isRequired: false,
                    maxLength: null,
                }
            },
            {
                DisplayName: 'Collection Date *',
                FieldTypeID: CustomFields.DATETIME_FIELD,
                Options: {
                    isRequired: true,
                }
            },
            {
                DisplayName: 'Test Ordered Date *',
                FieldTypeID: CustomFields.DATETIME_FIELD,
                Options: {
                    isRequired: true,
                }
            }
        ]

        let tableFields = allCustomQuestions && allCustomQuestions.length > 0 ? allCustomQuestions : [];
        let combinedCustomFields = tableFields.concat(serviceFields);
        // console.log('combinedCustomFields', combinedCustomFields)

        let jsx = [];
        for (let i = 0; i < tableData.length; i++) {
            let row = [];
            let keys = Object.keys(tableData[i])
            row.push(<td className="pt-3">{i + 1}</td>)
            for (let j = 0; j < keys.length; j++) {
                if (!combinedCustomFields || combinedCustomFields.length < 1) {
                    sweetalert.fire({ icon: 'error', title: '', text: 'CSV Column headers not found. Re-check CSV column headers.' })
                }
                for (let k = 0; k < combinedCustomFields.length; k++) {
                    if (combinedCustomFields[k].DisplayName === keys[j]) { // DisplayName matches key verbatim
                        if (combinedCustomFields[k].FieldTypeID === CustomFields.TEXT_FIELD) {
                            row.push(
                                <td key={keys[j]} className="TableDataWrap" style={{ width: '17rem' }}>
                                    <input
                                        className="form-control"
                                        autoComplete={"off"}
                                        type="text"
                                        value={tableData[i][keys[j]]}
                                        onBlur={(e) => validate(i, keys[j], combinedCustomFields[k])}
                                        onChange={(e) => handleCellChange(e, i, keys[j], combinedCustomFields[k].FieldTypeID)}
                                    />
                                </td>
                            )
                        }
                        else if (combinedCustomFields[k].FieldTypeID === CustomFields.EMAIL_FIELD) {
                            row.push(
                                <td key={keys[j]} className="TableDataWrap" style={{ width: '17rem' }}>
                                    <input
                                        className="form-control"
                                        autoComplete={"off"}
                                        type="email"
                                        value={tableData[i][keys[j]]}
                                        onBlur={(e) => validate(i, keys[j], combinedCustomFields[k])}
                                        onChange={(e) => handleCellChange(e, i, keys[j], combinedCustomFields[k].FieldTypeID)}
                                    />
                                </td>
                            )
                        }
                        else if (combinedCustomFields[k].FieldTypeID === CustomFields.TEXTAREA_FIELD) {
                            row.push(
                                <td key={keys[j]} className="TableDataWrap" style={{ width: '17rem' }}>
                                    <textarea
                                        maxLength={combinedCustomFields[k].Options.maxLength}
                                        rows={1}
                                        className={'form-control'}
                                        autoComplete={"off"}
                                        value={tableData[i][keys[j]]}
                                        onBlur={(e) => validate(i, keys[j], combinedCustomFields[k])}
                                        onChange={(e) => handleCellChange(e, i, keys[j], combinedCustomFields[k].FieldTypeID)}
                                    />
                                </td>
                            )
                        }
                        else if (combinedCustomFields[k].FieldTypeID === CustomFields.DATETIME_FIELD) {
                            row.push(
                                <td key={keys[j]} className="TableDataWrap" style={{ width: '17rem' }}>
                                    <input
                                        className={"form-control"}
                                        autoComplete={"off"}
                                        type={"datetime-local"}
                                        value={parseDateForCSVImport(tableData[i][keys[j]], true)}
                                        onBlur={(e) => validate(i, keys[j], combinedCustomFields[k])}
                                        onChange={(e) => {
                                            handleCellChange(e.target.value, i, keys[j], combinedCustomFields[k].FieldTypeID)
                                        }}
                                    />
                                    {/* <DatePicker
                                        disableCalendar={true}
                                        className="form-control"
                                        onChange={(e) => {
                                            handleCellChange(e, i, keys[j], combinedCustomFields[k].FieldTypeID)
                                        }}
                                        value={tableData[i][keys[j]] ? new Date(tableData[i][keys[j]]) : null}
                                    /> */}
                                </td>
                            )
                        }
                        else if (combinedCustomFields[k].FieldTypeID === CustomFields.DATE_FIELD) {
                            row.push(
                                <td key={keys[j]} className="TableDataWrap" style={{ width: '17rem' }}>
                                    <input
                                        className={"form-control"}
                                        autoComplete={"off"}
                                        type={"date"}
                                        value={parseDateForCustomDate(tableData[i][keys[j]], false)}
                                        onBlur={(e) => validate(i, keys[j], combinedCustomFields[k])} 
                                        onChange={(e) => {
                                            handleCellChange(e.target.value, i, keys[j], combinedCustomFields[k].FieldTypeID)
                                        }}
                                    />
                                    {/* <DatePicker
                                        disableCalendar={true}
                                        className="form-control"
                                        onChange={(e) => {
                                            handleCellChange(e, i, keys[j], combinedCustomFields[k].FieldTypeID)
                                        }}
                                        value={tableData[i][keys[j]] ? new Date(tableData[i][keys[j]]) : null}
                                    /> */}
                                </td>
                            )
                        }
                        else if (combinedCustomFields[k].FieldTypeID === CustomFields.NUMBER_FIELD) {
                            row.push(
                                <td key={keys[j]} className="TableDataWrap" style={{ width: '17rem' }}>
                                    <input
                                        min={combinedCustomFields[k].Options.min}
                                        max={combinedCustomFields[k].Options.max}
                                        className="form-control"
                                        autoComplete={"off"}
                                        type="number"
                                        value={tableData[i][keys[j]]}
                                        onBlur={(e) => validate(i, keys[j], combinedCustomFields[k])}
                                        onChange={(e) => handleCellChange(e, i, keys[j], combinedCustomFields[k].FieldTypeID)}
                                    />
                                </td>
                            )
                        }
                        else if (combinedCustomFields[k].FieldTypeID === CustomFields.PHONE_FIELD) {
                            row.push(
                                <td key={keys[j]} className="TableDataWrap" style={{ width: '17rem' }}>
                                    <input
                                        placeholder="Enter phone #"
                                        className="form-control"
                                        autoComplete={"off"}
                                        type="tel"
                                        value={tableData[i][keys[j]]}
                                        onBlur={(e) => validate(i, keys[j], combinedCustomFields[k])}
                                        onChange={(e) => handleCellChange(e, i, keys[j], combinedCustomFields[k].FieldTypeID)}
                                    />
                                </td>
                            )
                        }
                        else if (combinedCustomFields[k].FieldTypeID === CustomFields.CHECKBOX_FIELD) {
                            row.push(
                                <td key={keys[j]} className="TableDataWrap" style={{ width: '17rem' }}>
                                    <input
                                        className="form-control"
                                        autoComplete={"off"}
                                        type="checkbox"
                                        checked={tableData[i][keys[j]] === 'True' ? true : false}
                                        value={tableData[i][keys[j]]}
                                        onClick={(e) => {
                                            // console.log(e) 
                                            let updatedData = [...tableData];
                                            //@ts-ignore
                                            updatedData[i][keys[j]] = e.target.checked ? 'True' : 'False';
                                            setTableData(updatedData);
                                        }}
                                    />
                                </td>
                            )
                        }
                        else if (combinedCustomFields[k].FieldTypeID === CustomFields.SELECT_FIELD) {
                            let valueObj;
    
                            // console.log(`key: ${keys[j]}, value: ${tableData[i][keys[j]]}`)

                            if (!tableData[i][keys[j]] || tableData[i][keys[j]].length < 1) {
                                valueObj = null;
                            }
                            else if (Array.isArray(tableData[i][keys[j]])) {
                                valueObj = tableData[i][keys[j]];
                            }
                            else if (combinedCustomFields[k].DisplayName != 'Specimen Source' && !Number(tableData[i][keys[j]]) && typeof tableData[i][keys[j]] == 'string' && tableData[i][keys[j]].includes(',')) {
                                let splitStringArray = tableData[i][keys[j]].split(",");
                                if (!combinedCustomFields[k].Options.isMulti) {
                                    const cellText = tableData[i][keys[j]].trim().toLowerCase();
                                    const wholeCellOption = combinedCustomFields[k].Options.options ? combinedCustomFields[k].Options.options.find(o =>
                                        (typeof o.label === 'string' && o.label.trim().toLowerCase() === cellText) ||
                                        (typeof o.value === 'string' && o.value.trim().toLowerCase() === cellText)) : null;

                                    if (wholeCellOption) {
                                        // the option label itself contains a comma, so this is one selection
                                        valueObj = { label: wholeCellOption.label, value: wholeCellOption.value };
                                    }
                                    else if (!splitStringArray || splitStringArray.length > 1) {
                                        // Returning the sweetalert from this function replaces the table rows with
                                        // the alert object, which React cannot render. Warn once per cell after
                                        // render instead and leave the cell empty for the user to correct.
                                        const warningKey = `${i}-${keys[j]}`;
                                        if (!multipleSelectionWarnings.current.has(warningKey)) {
                                            multipleSelectionWarnings.current.add(warningKey);
                                            let displayName = combinedCustomFields[k].DisplayName;
                                            let rowNumber = i + 1;
                                            setTimeout(() => sweetalert.fire({ icon: 'error', title: '', html: `<p><b>Row ${rowNumber}: ${displayName}</b> cannot have multiple selections</p>` }), 0);
                                        }
                                        valueObj = null;
                                    }
                                    else {
                                        valueObj = { label: tableData[i][keys[j]].trim(), value: tableData[i][keys[j]].trim() }
                                    }
                                }
                                else {
                                    if (splitStringArray && splitStringArray.length > 0) {
                                        valueObj = [];
                                        if (combinedCustomFields[k].DisplayName == 'Tests *') {
                                            for (let i = 0; i < combinedCustomFields[k].Options.options.length; i++) {
                                                for (let j = 0; j < splitStringArray.length; j++) {
                                                    if (combinedCustomFields[k].Options.options[i].label === splitStringArray[j].trim()) {
                                                        valueObj.push(combinedCustomFields[k].Options.options[i])
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            splitStringArray.map(a => {
                                                valueObj.push({ label: a.trim(), value: a.trim() });
                                            })
                                        }
                                    }
                                    else {
                                        valueObj = null;
                                    }
                                }
                            }
                            else {
                                // Check if value is already an object first
                                if (typeof tableData[i][keys[j]] === 'object') {
                                    valueObj = tableData[i][keys[j]];
                                }
                                else if (combinedCustomFields[k].DisplayName == 'Specimen Source *' && Number(tableData[i][keys[j]])) {
                                    valueObj = { label: importedCSVSpecimenSources.find(f => f.value === tableData[i][keys[j]]).label, value: tableData[i][keys[j]] }
                                }
                                else if (combinedCustomFields[k].DisplayName == 'Tests *' && Number(tableData[i][keys[j]])) {
                                    valueObj = { label: importedCSVTests.find(f => f.ID === tableData[i][keys[j]]).Name, value: tableData[i][keys[j]] }
                                }
                                else if (combinedCustomFields[k].DisplayName == 'Provider Full Name (NPI #) *') {
                                  try{
                                    valueObj = { label: selectedFacilitySubmittingProviders.find(f => (f.label === tableData[i][keys[j]] || f.label === tableData[i][keys[j]].label || f.value === tableData[i][keys[j]])).label, value: tableData[i][keys[j]] }
                                  } catch (err) {
                                    // write label to value instead of ContactID, validation will catch it on Submit
                                    valueObj = {label: tableData[i][keys[j]], value: tableData[i][keys[j]]}
                                  }
                                }
                                else if (Number(tableData[i][keys[j]])) {
                                    valueObj = { label: tableData[i][keys[j]], value: tableData[i][keys[j]] }
                                }
                                else if (combinedCustomFields[k].Options.isBoolean) {
                                    // console.log('combinedCustomFields[k].Options.isBoolean', combinedCustomFields[k].DisplayName, tableData[i][keys[j]])
                                    const yesNoOption = getYesNoOption(combinedCustomFields[k], tableData[i][keys[j]]);
                                    valueObj = yesNoOption ? { label: yesNoOption.label, value: yesNoOption.value } : null;
                                }
                                else if (typeof tableData[i][keys[j]] === 'string') {
                                    valueObj = { label: tableData[i][keys[j]], value: tableData[i][keys[j]] };
                                }
                            }

                            // console.log(combinedCustomFields[k].DisplayName, valueObj)

                            row.push(
                                <td key={keys[j]} className="TableDataWrap" style={{ width: '17rem' }}>
                                    <Select
                                        menuPortalTarget={document.body} // Ensures the dropdown renders outside of overflow restrictions
                                        menuPosition="absolute" // Keeps the menu positioned within the scroll context
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensure portal has high zIndex
                                            menu: (provided) => ({ ...provided, zIndex: 9999 }), // Ensure menu has high zIndex
                                        }}
                                        menuPlacement={i > 3 && i > (tableData.length - 7) ? "top" : "bottom"}
                                        isMulti={combinedCustomFields[k].Options.isMulti}
                                        isSearchable={true}
                                        isClearable={combinedCustomFields[k].Options.isMulti ? false : !combinedCustomFields[k].Options.isMulti && combinedCustomFields[k].Options.isRequired ? false : true}
                                        placeholder={"Please select..."}
                                        className={"state_select"}
                                        options={combinedCustomFields[k].Options.options}
                                        value={valueObj}
                                        onBlur={(e) => validate(i, keys[j], combinedCustomFields[k])}
                                        onChange={(e) => handleCellChange(e, i, keys[j], combinedCustomFields[k].FieldTypeID)}
                                    />
                                </td>
                            )
                        }
                    } else { // Maybe DisplayName doesn't match key verbatim (for special cases)
                      if(combinedCustomFields[k].DisplayName === 'Check if patient has No Private Insurance AND No MaineCare coverage' && keys[j] === 'No Insurance/ No MaineCare'){
                            row.push(
                                <td key={keys[j]} className="TableDataWrap" style={{ width: '17rem' }}>
                                    <input
                                        className="form-control"
                                        autoComplete={"off"}
                                        type="checkbox"
                                        checked={tableData[i][keys[j]] === 'True' ? true : false}
                                        value={tableData[i][keys[j]]}
                                        onClick={(e) => {
                                            // console.log(e) 
                                            let updatedData = [...tableData];
                                            //@ts-ignore
                                            updatedData[i][keys[j]] = e.target.checked ? 'True' : 'False';
                                            setTableData(updatedData);
                                        }}
                                    />
                                </td>
                            )
                      }
                    }
                }
            }
            jsx.push(<tr key={i}>{row}</tr>)
        }
        return jsx;
    }

    const generateExcelDoc = () => {
        setShowLoading(true)
        if (!selectedFacility || !selectedService) {
            setShowLoading(false);
            return sweetalert.fire({ icon: 'error', title: "", text: "Facility and Service must be selected" })
        }
        SamplesAPI.generateExcelDocBasedOnService(selectedService.value, selectedFacility.value)
            .then(blobUrl => {
                if (typeof blobUrl === 'string') {
                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = `${selectedService.label} Service.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(blobUrl);
                }
                else {
                    console.error('Error from server:', blobUrl);
                    return sweetalert.fire({ icon: 'error', title: '', text: 'Error when downloading excel doc. Please try again.' })
                }
            })
            .catch(error => {
                console.error('Error downloading the file:', error);
                return sweetalert.fire({ icon: 'error', title: '', text: 'Error when downloading excel doc. Please try again.' })
            })
            .finally(() => {
                setShowLoading(false);
            });


    }

    const getFacilityServices = () => {
        let facility = facilities && facilities.length > 0 && selectedFacility && selectedFacility.value ? facilities.find(f => f.ID === selectedFacility.value) : null
        let facilityServiceIDs = facility && facility.ServiceIDs ? JSON.parse(facility.ServiceIDs) : null;
        let availableServicesLabels = facilityServiceIDs ?
            services.filter(s => facilityServiceIDs.includes(s.ID)) :
            [];
        return availableServicesLabels
            .sort((a, b) => a.Name.localeCompare(b.Name))
            .map(s => { return { label: s.Name, value: s.ID } });
    }

    const getSubmittingProvidersForSelectedFacility = () => {
        let facilityProviders = allSubmittingProviders.filter(p => p.FacilityID === importedCSVFacility?.value);
        let selectabledProviders = facilityProviders?.map(fp => {return {label:`${fp.FullName} (${fp.NPI_Number})`, value: fp.ContactID}})
        setSelectedFacilitySubmittingProviders(selectabledProviders);
    }

    return (
        <div className="container-fluid">
            <Overlay show_loading={showLoading} />
            <div className={"row"}>
                <div className="col-12 col-lg-6 pt-2">
                    <div className="card mb-2">
                        <div className="card-header verlag-bold">
                            <h4>Template Download</h4>
                        </div>
                        <div className="card-body">


                            {buildRow("Facility", <Select
                                id={"Service"}
                                isSearchable={true}
                                placeholder={"Please Select..."}
                                noOptionsMessage={() => "No option"}
                                className={"state_select"}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                options={facilities.map(s => { return { label: s.FacilityName, value: s.ID } })}
                                onChange={(e) => {
                                    setSelectedFacility(e)
                                    setSelectedService(null)
                                }}
                                value={selectedFacility}
                            />,
                                "Facility"
                            )}
                            {buildRow("Test Order", <Select
                                id={"Service"}
                                isDisabled={selectedFacility ? false : true}
                                isSearchable={true}
                                placeholder={"Please Select..."}  
                                noOptionsMessage={() => "No option"}
                                className={"state_select"}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                options={getFacilityServices()}
                                onChange={(e) => setSelectedService(e)}
                                value={selectedService}
                            />,
                                "Service"
                            )}
                            </div>

                            <div className="card-footer">
                                <button className={"btn immySubmitButtonOutline"}
                                    onClick={() => generateExcelDoc()}
                                >Download</button>
                                <button className="btn immyClearButtonOutline float-right"
                                    onClick={() => {
                                        setSelectedFacility(null);
                                        setSelectedService(null)
                                    }}
                                >Clear</button>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-6 pt-2">
                        <div className="card mb-2">
                            <div className="card-header verlag-bold">
                                <h4>File Upload
                                    <span className="float-right text-danger">*file must be saved as .csv</span>
                                </h4>
                            </div>
                            <div className="card-body">
                                <CSVReader
                                    onUploadRejected={(e) => {
                                        return sweetalert.fire({ icon: 'error', title: '', text: 'File must be saved as a .csv' })
                                    }}
                                    onDragOver={(event: DragEvent) => {
                                        event.preventDefault();
                                        setZoneHover(true);
                                    }}
                                    onDragLeave={(event: DragEvent) => {
                                        event.preventDefault();
                                        setZoneHover(false);
                                    }}
                                    onUploadAccepted={(results: any) => {
                                        setShowLoading(true)
                                        //if results.data.length is less than 10 then it is just headers
                                        if (!results || !results.data || results.data.length < 10) {
                                            setShowLoading(false)
                                            return sweetalert.fire({ icon: 'error', title: '', text: 'No Samples found on csv' })
                                        }

                                        if (results && results.data && results.data.length > 91) {
                                            setShowLoading(false)
                                            return sweetalert.fire({ icon: 'error', title: '', text: 'Please limit CSV to 80 rows' })
                                        }

                                        let facility = results.data[0][6] ? JSON.parse(results.data[0][6]) : null;
                                        // console.log('facility from csv', facility)
                                        if (!facility) {
                                            setShowLoading(false)
                                            return sweetalert.fire({ icon: 'error', title: '', text: `CSV is corrupt. This is likely due to changes made to CSV directly. All changes need to be made to Excel document and then saved as CSV.` })
                                        }
                                        setImportedCSVFacility({ label: facility.FacilityName, value: facility.ID });

                                        let service = results.data[0][5] ? JSON.parse(results.data[0][5]) : null;
                                        if (!service) {
                                            setShowLoading(false)
                                            return sweetalert.fire({ icon: 'error', title: '', text: `CSV is corrupt. This is likely due to changes made to CSV directly. All changes need to be made to Excel document and then saved as CSV.` })
                                        }
                                        setImportedCSVService(service);
                                        let tests = results.data[1][5] ? JSON.parse(results.data[1][5]) : null;
                                        if (!tests || tests.length < 1) {
                                            setShowLoading(false)
                                            return sweetalert.fire({ icon: 'error', title: '', text: `CSV is corrupt. This is likely due to changes made to CSV directly. All changes need to be made to Excel document and then saved as CSV.` })
                                        }
                                        setImportedCSVTests(tests)
                                        let specimenSources = results.data[2][5] ? JSON.parse(results.data[2][5]) : null;
                                        if (!specimenSources || specimenSources.length < 1) {
                                            setShowLoading(false)
                                            return sweetalert.fire({ icon: 'error', title: '', text: `CSV is corrupt. This is likely due to changes made to CSV directly. All changes need to be made to Excel document and then saved as CSV.` })
                                        }
                                        setImportedCSVSpecimenSources(specimenSources)

                                        // Note: we were validating providers against the list provided in the CSV, but that list may not match the selected facility's providers
                                        //    Decided to validate against selected facility's providers only incase user tried to adjust list in xlsx/csv
                                        // let submittingProviders = [];
                                        
                                        // if(results.data[3][5] && results.data[3][5].length > 0) {
                                        //     submittingProviders = [...JSON.parse(results.data[3][5]), ...JSON.parse(results.data[4][5])];
                                        // }
                                        
                                        // if (!submittingProviders || submittingProviders.length < 1) {
                                        //     setShowLoading(false)
                                        //     return sweetalert.fire({ icon: 'error', title: '', text: `CSV is corrupt. This is likely due to changes made to CSV directly. All changes need to be made to Excel document and then saved as CSV.` })
                                        // }

                                        // setImportedCSVSubmittingProviders(submittingProviders)

                                        let headers = results.data[9];
                                        let tempArray = results.data.slice(10);

                                        //check for empty arrays
                                        let nonEmptyArray = tempArray.filter(innerArr => !innerArr.every(element => element === ""));

                                        // we pre-populate Tests * field, will need to eliminate any rows that do not contain FirstName (or any other required field)
                                        let rowOnlyHasTestData = nonEmptyArray.filter(innerArr => innerArr.every((element, index) => {
                                            if (headers[index] === 'Tests *') {
                                                return element !== "";
                                            }
                                            return element === "";
                                        }));

                                        //remove rows from nonEmptyArray that only have test data
                                        nonEmptyArray = nonEmptyArray.filter(innerArr => !rowOnlyHasTestData.includes(innerArr));

                                        //get total number of columns from combined 
                                        let serviceSpecificCustomQuestions = [];
                                        for (let i = 0; i < allCustomQuestions.length; i++) {
                                            let customFieldHeader = allCustomQuestions[i].DisplayName && allCustomQuestions[i].Options.isRequired ? `${allCustomQuestions[i].DisplayName} *` : `${allCustomQuestions[i].DisplayName}`;
                                            if(allCustomQuestions[i].DisplayName === "Check if patient has No Private Insurance AND No MaineCare coverage"){
                                                allCustomQuestions[i].DisplayName = "No Insurance/ No MaineCare"
                                            }
                                            if(allCustomQuestions[i].DisplayName.includes('Provider')) {
                                                allCustomQuestions[i].DisplayName = "Provider Full Name (NPI #) *"
                                            }
                                            if (allCustomQuestions[i].ServiceID) {
                                                if (allCustomQuestions[i].ServiceID === service.ID) {
                                                    allCustomQuestions[i].DisplayName = customFieldHeader
                                                    serviceSpecificCustomQuestions.push(allCustomQuestions[i])
                                                }
                                            }
                                            else {
                                                allCustomQuestions[i].DisplayName = customFieldHeader
                                                serviceSpecificCustomQuestions.push(allCustomQuestions[i])
                                            }

                                            // NPI # does not need to be included here
                                            serviceSpecificCustomQuestions = serviceSpecificCustomQuestions.filter(sq => sq.DisplayName !== "NPI #") 
                                        }

                                        //serviceSpecificCustomQuestions.length + 7 is for the 7 hard-coded required fields
                                        if (serviceSpecificCustomQuestions && serviceSpecificCustomQuestions.length > 0 && 
                                          headers && headers.length > 0 && serviceSpecificCustomQuestions.length + 7 !== headers.length) {

                                            // console.log('headers', headers)
                                            // console.log('serviceSpecificCustomQuestions', serviceSpecificCustomQuestions)
                                            setShowLoading(false)
                                            return sweetalert.fire({ icon: 'error', title: '', text: `Something went wrong. Make sure you are using the latest Excel document.` })
                                        }

                                        setAllCustomQuestions(serviceSpecificCustomQuestions)

                                        const keys = headers;
                                        const objectsArray = nonEmptyArray.map((item, index) => {
                                            let obj = {};
                                            keys.forEach((key, index) => {
                                                if( key === "No Insurance/ No MaineCare"){
                                                    obj[key] = item[index] === "Yes" ? "True" : "False";
                                                } else {
                                                    obj[key] = item[index];
                                                }
                                            });
                                            return obj;
                                        })
                                        //need a date check
                                        // console.log('objectsArray', objectsArray)
                                        setTableData(objectsArray)
                                        setShowLoading(false)
                                    }}
                                >
                                    {({
                                        getRootProps,
                                        acceptedFile,
                                        ProgressBar,
                                        getRemoveFileProps,
                                        Remove,
                                    }: any) => (
                                        <>
                                            <div
                                                {...getRootProps()}
                                                style={Object.assign(
                                                    {},
                                                    styles.zone,
                                                    zoneHover && styles.zoneHover
                                                )}
                                            >
                                                {acceptedFile ? (
                                                    <>
                                                        <div style={styles.file}>
                                                            <div style={styles.info}>
                                                                <span style={styles.size}>
                                                                    {formatFileSize(acceptedFile.size)}
                                                                </span>
                                                                <span style={styles.name}>{acceptedFile.name}</span>
                                                            </div>
                                                            <div style={styles.progressBar}>
                                                                <ProgressBar />
                                                            </div>
                                                            <div
                                                                {...(() => {
                                                                    const originalRemoveProps = getRemoveFileProps();
                                                                    const originalOnClick = originalRemoveProps.onClick;

                                                                    return {
                                                                        ...originalRemoveProps,
                                                                        onClick: (event) => {
                                                                            clearTable()
                                                                            if (originalOnClick) {
                                                                                originalOnClick(event);
                                                                            }
                                                                        }
                                                                    };
                                                                })()}
                                                                style={styles.remove}
                                                            >
                                                                <Remove color={removeHoverColor} />
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    'Drop CSV file here or click to upload'
                                                )}
                                            </div>
                                        </>
                                    )}
                                </CSVReader>
                                <div className="form-group row" style={{ marginRight: '5px' }}>
                                    <label htmlFor="ImportedFacility" className="col-sm-4 col-form-label" style={{ fontWeight: 'bold' }}>Importing Facility</label>
                                    <div className="col-sm-8 p-0 m-0" style={{ zIndex: 30 }}>
                                        <Select
                                            id={"ImportingFacility"}
                                            isSearchable={true}
                                            placeholder={"Please Select..."}
                                            noOptionsMessage={() => "No option"}
                                            className={"state_select"}
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                            options={facilities.map(s => { return { label: s.FacilityName, value: s.ID } })}
                                            onChange={(e) => {
                                                setImportedCSVFacility(e)
                                                getSubmittingProvidersForSelectedFacility();
                                            }}
                                            value={importedCSVFacility}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                    {tableData && tableData.length > 0 && (
                        <div className="col-md-12 pt-2">
                            <div className="card mt-2 mb-5">
                                <div className="card-header verlag-bold stickToTop"> {/** removed zIndex to prevent hiding Test Order dropdown options **/}
                                    <h4 className="text-center text-md-left">
                                        Rows
                                        <section className="tableHeaderSection float-md-right d-flex justify-content-around">
                                            <h4 className={"float-md-right"}>
                                                Total: {tableData.length}
                                            </h4>
                                        </section>


                                        {tableData && tableData.length > 0 && tableData[0].ReqNum &&
                                            <button
                                                className={"d-none d-md-inline btn btn-outline-primary ml-3"}
                                                onClick={() => handleExportToCSV()}
                                            >
                                                Export to CSV
                                            </button>
                                        }
                                    </h4>
                                </div>


                                <div className="card-body p-0 m-0 table-responsive" style={tableData && tableData.length > 0 && tableData[0].ReqNum ? {} : { overflowY: "auto", maxHeight: '800px' }}>
                                    {tableData && tableData.length > 0 && tableData[0].ReqNum ?
                                        <SimpleTable
                                            columns={[
                                                { label: "Confirmation #", key: "ReqNum", popoverText: "Click to sort by Confirmation Number" },
                                                { label: "Patient UID", key: "PatientPortalUID" },
                                                { label: "First Name", key: "PatientFirstName" },
                                                { label: "Last Name", key: "PatientLastName" },
                                                { label: "Date of Birth", key: "PatientDOB", formatFunc: parseDate },
                                            ]}
                                            table_data={tableData} table_style="tableFixHead"
                                        />
                                        :
                                        <table className="table p-0 m-0" style={{ tableLayout: "fixed" }}>
                                            {/** thead needs its own zIndex: position sticky creates a stacking context, so the
                                                 zIndex on each th is scoped to the thead and cannot beat the react-select
                                                 controls in tbody (react-select's control is position: relative).
                                                 Keep this low: #main is a sticky stacking context at zIndex 100, so the
                                                 sidebar/overlay (998) effectively paint at 100. Anything >= 100 here draws
                                                 over the open sidebar. 2 is enough to beat the row controls.
                                                 The selects outside the table portal their menus to document.body so they
                                                 are not hidden by this. **/}
                                            <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                                                <tr>
                                                    {getTableHeaders()}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getTableRows()}
                                            </tbody>
                                        </table>
                                    }
                                </div>
                                <div className="card-footer">
                                    {submitButtonClicked ? <div className="d-none"></div> :
                                        <button
                                            className={"btn immySubmitButtonOutline float-right mr-5"}
                                            onClick={() => {
                                                validateTable()
                                            }}
                                        >
                                            Submit
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    )}


                </div>
            </div>
            );
}